import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";

interface BranchProps {
  branch: any;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

const BranchShop = ({ branch, onEditClick, onDeleteClick }: BranchProps) => {
  const name = branch.name;
  const nameIcon = name.charAt(0);

  return (
    <>
      <Card
        className="d-flex flex-column"
        style={{ minHeight: "100px", overflow: "hidden" }}
      >
        <Row noGutters>
          {" "}
          <Col xl="5">
            <div className="text-center p-4 border-end">
              <div className="avatar-sm mx-auto mb-3 mt-1">
                <span
                  className={
                    "avatar-title rounded-circle bg-" +
                    branch.color +
                    "-subtle text-" +
                    branch.color +
                    " font-size-16"
                  }
                >
                  {nameIcon}
                </span>
              </div>
              <h5 className="text-truncate pb-1">{branch.name}</h5>
            </div>
          </Col>
          <Col xl="7" sm="12">
            <div className="px-4 pb-4 pt-2 text-center text-xl-start">
              <UncontrolledDropdown className="m-0 text-end p-0">
                <DropdownToggle
                  className="btn btn-link text-muted mt-n2"
                  tag="a"
                >
                  <i className="mdi mdi-dots-horizontal font-size-20"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    className="text-info"
                    onClick={onEditClick}
                  >
                    <i className="mdi mdi-pencil-outline me-2"></i>
                    Edit
                  </DropdownItem>
                  <DropdownItem
                    href="#"
                    className="text-danger"
                    onClick={onDeleteClick}
                  >
                    <i className="mdi mdi-delete-outline me-2"></i>
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <Row>
                <Col className="text-wrap mx-auto" xs="6">
                  <div>
                    <p className="mb-2 text-truncate">Products</p>
                    <h5>{branch.number_of_products}</h5>
                  </div>
                </Col>
                <Col className="text-wrap mx-auto" xs="6">
                  <div>
                    <p className="mb-2 text-truncate">Wallet</p>
                    <h5 className="text-wrap">{branch.total_revenue}</h5>
                  </div>
                </Col>
              </Row>
              <div className="mt-4 text-center">
                <Link
                  to="/branch-analytics"
                  className="text-decoration-underline text-reset"
                >
                  See Profile <i className="mdi mdi-arrow-right"></i>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default BranchShop;
